import config from "../config";
import request, {
  requestOptions,
  requestOptionsFormData,
} from "../utils/request";

const baseUrl = `${config.API_ROOT}/app/web-chat`;

const WebChat = {
  async getCompanyInfo({ id }: { id: string }) {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/${id}`;
    const { data } = await request(url, options);
    return data as {
      ok: boolean;
      company?: { name: string; plan?: string | null };
    };
  },
  async sendMessage({
    webId,
    content,
    companyId,
    replyTo,
    name,
  }: {
    webId: string | undefined;
    content: string;
    companyId: string;
    replyTo?: string;
    name?: string;
  }) {
    const options = await requestOptions(
      "POST",
      { webId, content, companyId, replyTo, name },
      true,
    );
    const url = `${baseUrl}/message`;
    const { data } = await request(url, options);
    return data as { ok: boolean; webId: string; companyId: string };
  },
  async readMessages({
    webId,
    companyId,
    lastId,
  }: {
    webId: string;
    companyId: string;
    lastId: string;
  }) {
    const options = await requestOptions(
      "POST",
      { webId, companyId, lastId },
      true,
    );
    const url = `${baseUrl}/read`;
    const { data } = await request(url, options);
    return data as { ok: boolean };
  },
  async deliveredMessages({
    webId,
    companyId,
    lastId,
  }: {
    webId: string;
    companyId: string;
    lastId: string;
  }) {
    const options = await requestOptions(
      "POST",
      { webId, companyId, lastId },
      true,
    );
    const url = `${baseUrl}/delivered`;
    const { data } = await request(url, options);
    return data as { ok: boolean };
  },
  async uploadMedia(webId: string, formData: FormData) {
    const options = await requestOptionsFormData(formData, true);
    const url = `${baseUrl}/${webId}/media`;
    return request(url, options);
  },
};

export default WebChat;
